import { ActionReducer, INIT, UPDATE } from '@ngrx/store';
import { StoreStateInterface } from '../../interfaces/store-state.interface';

export const hydrationMetaReducer = (
  reducer: ActionReducer<StoreStateInterface>
): ActionReducer<StoreStateInterface> => {
  return (state, action) => {
    const storeStateKey = 'app_storeState';

    if (action.type === INIT || action.type === UPDATE) {
      const storageValue = sessionStorage.getItem(storeStateKey);

      if (storageValue) {
        try {
          return JSON.parse(storageValue);
        } catch {
          sessionStorage.removeItem(storeStateKey);
        }
      }
    }

    const nextState = reducer(state, action);

    try {
      sessionStorage.setItem(storeStateKey, JSON.stringify(nextState));
    } catch (error) {
      console.error('Não foi possível fazer cache. Session Storage cheio ou desabilitado.');
    }

    return nextState;
  };
};
